import React, { useState, useEffect } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Tooltip,
  TextField,
  Button,
   TablePagination
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "../../Components/Sidebar";
import { Card, CardContent } from "@mui/material";
import TableSortLabel from '@mui/material/TableSortLabel';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip as RechartTooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { PieChart, Pie, Cell, } from "recharts";




const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Analytics
  const [avgResponseTime, setAvgResponseTime] = useState(0);
  const [loginsChartData, setLoginsChartData] = useState([]);
  const [queriesChartData, setQueriesChartData] = useState([]);
  const [analyticsError, setAnalyticsError] = useState(null);

const [totalQueries, setTotalQueries] = useState(0);
const [queriesError, setQueriesError] = useState(null);

const [roleData, setRoleData] = useState({ admins: 0, users: 0, total: 0 });
const [roleError, setRoleError] = useState(null);




const [logs, setLogs] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState("");
const [page, setPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalCount, setTotalCount] = useState(0);
// for Response Time column

const [emailFilter, setEmailFilter] = useState("");
const [queryFilter, setQueryFilter] = useState("");

// sort states
const [sortBy, setSortBy] = useState("question_time"); // default column
const [order, setOrder] = useState("desc");            // default order

// individual arrows state
const [responseTimeOrder, setResponseTimeOrder] = useState("asc");
const [questionTimeOrder, setQuestionTimeOrder] = useState("desc");
const backendURL = process.env.REACT_APP_TWCHATBOT_DOMAINS;


  const chartData = [
  { name: "Admins", value: roleData.admins, fill: "#20c997" },
  { name: "Users", value: roleData.users, fill: "#6610f2" },
];

const fetchLogs = async () => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      sort_by: sortBy,
      order,
      email: emailFilter,  // ✅ changed here
      query: queryFilter,
    });

    const response = await fetch(`${backendURL}/internal/admin_querylogs/?${params}`
    );
    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
    const data = await response.json();
    if (data.status === "success") {
      setLogs(data.data);
      setTotalCount(data.total_count);
    } else {
      setError("Failed to fetch logs");
    }
  } catch (err) {
    console.error(err);
    setError("Error fetching logs");
  } finally {
    setLoading(false);
  }
};


// refetch when params change
useEffect(() => {
  fetchLogs();
}, [page, pageSize, sortBy, order, emailFilter, queryFilter]);

  // Fetch avg response time
  useEffect(() => {
    const fetchAvgResponseTime = async () => {
      try {
      const response = await fetch(`${backendURL}/internal/avg_response_time/`
        );
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        setAvgResponseTime(data.avg_response_time || 0);
      } catch (err) {
        console.error(err);
        setAnalyticsError("Error fetching avg response time");
      }
    };
    fetchAvgResponseTime();
  }, []);


  useEffect(() => {
  const fetchTotalQueries = async () => {
    try {
      const response = await fetch(`${backendURL}/internal/total_queries_count/`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.status === 'success') {
        setTotalQueries(data.total_queries);
      } else {
        setQueriesError('Failed to load total queries');
      }
    } catch (err) {
      console.error(err);
      setQueriesError('Error fetching total queries');
    }
  };

  fetchTotalQueries();
}, []);


useEffect(() => {
  const fetchRoleData = async () => {
    try {
      const res = await fetch(`${backendURL}/internal/role_counts/`);
      if (!res.ok) throw new Error(`Status: ${res.status}`);
      const data = await res.json();
      if (data.status === "success") {
        console.log("Fetched role data:", data); 
        setRoleData({ total: data.total, admins: data.admins, users: data.users });
      } else {
        setRoleError("Failed to fetch role data");
      }
    } catch (err) {
      console.error(err);
      setRoleError("Error fetching role data");
    }
  };
  fetchRoleData();
}, []);


  // Fetch user logins bar chart data
  useEffect(() => {
    const fetchLoginsData = async () => {
      try {
      const response = await fetch(`${backendURL}/internal/user_logins_last_5_days/`
        );
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        setLoginsChartData(data.data || []);
      } catch (err) {
        console.error(err);
        setAnalyticsError("Error fetching user logins chart");
      }
    };
    fetchLoginsData();
  }, []);

  // Fetch queries per day chart data
  useEffect(() => {
    const fetchQueriesData = async () => {
      try {
      const response = await fetch(`${backendURL}/internal/queries_per_day_last_5_days/`
        );
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        setQueriesChartData(data.data || []);
      } catch (err) {
        console.error(err);
        setAnalyticsError("Error fetching queries chart");
      }
    };
    fetchQueriesData();
  }, []);


  const handleSort = (column) => {
  if (sortBy === column) {
    setOrder(order === 'asc' ? 'desc' : 'asc');
  } else {
    setSortBy(column);
    setOrder('asc');
  }
};

  return (
    <Grid container style={{ overflowX:"hidden" }}>
      {/* Sidebar Toggle */}
      {!sidebarOpen && (
        <Grid item xs={12}>
          <IconButton
            onClick={() => setSidebarOpen(true)}
            sx={{
              position: "fixed",
              marginTop: "64px",
              left: "16px",
              zIndex: 1300,
            }}
          >
            <MenuIcon style={{ color: "black" }} />
          </IconButton>
        </Grid>
      )}

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        currentPage="admin-dashboard"
        onClose={() => setSidebarOpen(false)}
        sidebarOpen={sidebarOpen}
        isAdminAuthenticated={true}
        sx={{
          width: sidebarOpen ? "20%" : "0",
          transition: "width 0.3s ease",
          "@media (max-width: 600px)": {
            width: sidebarOpen ? "100%" : "0",
          },
        }}
      />

      {/* Main Content */}
     <Grid
  item
  xs
  style={{
    display: "flex",
    flexDirection: "column",
    marginLeft: sidebarOpen ? "24.5%" : "0",
    width: sidebarOpen ? "75%" : "100%",
    transition: "all 0.3s ease",
    paddingTop: "50px", // pushes below navbar
    // paddingLeft: "24px",
    // paddingRight: "24px",
    boxSizing: "border-box",
  }}
>
  <Box sx={{ paddingBottom: 3 }}>
    <Paper
      sx={{
        padding: 3,
        borderRadius: "6px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        minHeight: "559px", // Adjust height as you need
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5F5F5",
      }}
    >
  

<Grid 
  container 
  spacing={2} // controls the gap between cards
  // sx={{ mt: 1, ml: 5 ,mr:5}} // remove custom ml
  sx={{
    mt: 1,
    ml: { xs: 1, sm: 5 },        // ✅ smaller left margin on mobile
    mr: { xs: 1, sm: 5 },        // ✅ smaller right margin on mobile
    pr: { xs: 5, sm: 0 },        // ✅ add right padding on mobile
  }}
>
  {/* Card 1 */}
  <Grid item xs={12} sm={6} md={3} lg={2}>
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: 3,
        height: { xs: "auto", sm: 180 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
      }}
    >
      <CardContent sx={{ width: "100%" }}>
        <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: "center" }}>
          Avg Response Time
        </Typography>
        <Box sx={{ textAlign: "center", mt: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#4E31AA",
              lineHeight: 1.5,
              wordWrap: "break-word",
            }}
          >
            {avgResponseTime}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px", lg: "15px" },
              color: "text.secondary",
              textAlign: "center",
              mt: 0.5,
            }}
          >
            seconds
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Grid>

  {/* Card 2 */}
  <Grid item xs={12} sm={6} md={3} lg={2}>
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: 3,
        height: { xs: "auto", sm: 180 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
      }}
    >
      <CardContent sx={{ width: "100%" }}>
        <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: "center" }}>
          Total Queries
        </Typography>
        <Box sx={{ textAlign: "center", mt: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#1976d2",
              lineHeight: 1.5,
              wordWrap: "break-word",
            }}
          >
            {totalQueries}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px", lg: "15px" },
              color: "text.secondary",
              textAlign: "center",
              mt: 0.5,
            }}
          >
            queries
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Grid>

  {/* Add more Grid items similarly */}
 <Grid item xs={12} sm={6} md={3} lg={2}>
  <Card
    sx={{
      borderRadius: 2,
      boxShadow: 3,
       height: { xs: "auto", sm: 180 }, // ✅ same as first two cards
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fff",
    }}
  >
    <CardContent sx={{ width: "100%", height: "100%" }}>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        sx={{ textAlign: "center" ,mt:3}}
      >
        Total : {roleData.total}
      </Typography>

      <Box sx={{ textAlign: "center", mt: 1,mb:1, height: 100 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart >
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={20}   // ✅ smaller to fit 180px height
              outerRadius={30}   // ✅ smaller to fit 180px height
              paddingAngle={5}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <RechartTooltip />
             {!sidebarOpen && (   // ✅ show legend only when sidebar is NOT open
  <Legend
    layout="horizontal"
    verticalAlign="bottom"
    align="center"
    iconType="circle"
    iconSize={10}
  />
)}

          </PieChart>
        </ResponsiveContainer>
      </Box>
    </CardContent>
  </Card>
</Grid>

</Grid>



          {analyticsError && (
            <Typography color="error">{analyticsError}</Typography>
          )}

    <Grid container spacing={2} sx={{ mt: 3 }}>
  {/* User Logins Chart */}
  <Grid item xs={12} md={6}>
    <Typography
  variant="h6"
  sx={{
    mb: 1,
    ml: { xs: 0, sm: 10, md: 20 }, // ✅ smaller margin-left on mobile
    textAlign: { xs: "center", sm: "left" }, // ✅ center text on mobile
  }}
>
  User Logins (Last 5 Working Days)
</Typography>

    <ResponsiveContainer width="95%" height={250}>
      <BarChart
        data={loginsChartData}
        layout="vertical" // date on Y, count on X
        margin={{ top: 10, right: 10, left: 60, bottom: 10 }} // give space for labels
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" domain={[0, 'auto']} />
        <YAxis type="category" dataKey="date" width={80} /> {/* width for full date */}
        <RechartTooltip />
        <Legend />
        <Bar dataKey="logins" fill="#8884d8" barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  </Grid>

  {/* Queries Per Day Chart */}
  <Grid item xs={12} md={6}>
    <Typography variant="h6" 
     sx={{
    mb: 1,
    ml: { xs: 0, sm: 10, md: 20 }, // ✅ smaller margin-left on mobile
    textAlign: { xs: "center", sm: "left" }, // ✅ center text on mobile
  }}>
      Queries Per Day (Last 5 Working Days)
    </Typography>
    <ResponsiveContainer width="95%" height={250}>
      <BarChart
        data={queriesChartData}
        layout="vertical"
        margin={{ top: 10, right: 10, left: 60, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" domain={[0, 'auto']} />
        <YAxis type="category" dataKey="date" width={80} /> {/* give room for date */}
        <RechartTooltip />
        <Legend />
        <Bar dataKey="queries" fill="#00D6AC" barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  </Grid>
</Grid>

<>
  {/* Filters */}
 <Box sx={{ display: "flex", gap: 2, mt: 2,ml:5 }}>
  <TextField
    label="Filter by Username"
    value={emailFilter}
    onChange={(e) => setEmailFilter(e.target.value)}
    variant="outlined"
    size="small"
  />
  <TextField
    label="Filter by Query"
    value={queryFilter}
    onChange={(e) => setQueryFilter(e.target.value)}
    variant="outlined"
    size="small"
  />
  {/* <Button
    variant="contained"
    onClick={() => {
      setPage(1);
      fetchLogs();
    }}
  >
    Apply
  </Button> */}
</Box>


  {/* Table */}
  {loading ? (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <CircularProgress />
    </Box>
  ) : error ? (
    <Typography color="error" sx={{ mt: 2 }}>
      {error}
    </Typography>
  ) : logs.length === 0 ? (
    <Typography sx={{ mt: 2 }}>No query logs found.</Typography>
  ) : (
    <>
      <TableContainer component={Paper}  sx={{
    mt: 3,
    ml: { xs: 1, sm: 5 }, // ✅ smaller left margin on mobile
    mr: { xs: 5, sm: 0 }, // ✅ add some right margin on mobile
    width: { xs: "calc(100% - 16px)", sm: "95%" }, // ✅ responsive width
    overflowX: "auto",
  }}>
        <Table size="small" sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
            <TableRow>
             <TableCell sx={{ fontWeight: "bold" }}>S.No</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Query</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Response</TableCell>
              {/* Sortable Response Time */}
             {/* Response Time header */}
<TableCell sortDirection={sortBy === "response_time" ? order : false}>
  <TableSortLabel
    active={true}
    direction={responseTimeOrder}
    onClick={() => {
      const newOrder = responseTimeOrder === "asc" ? "desc" : "asc";
      setResponseTimeOrder(newOrder);  // update visual arrow
      setSortBy("response_time");      // tell backend
      setOrder(newOrder);              // tell backend
    }}
  >
    Response Time
  </TableSortLabel>
</TableCell>

{/* Question Time header */}
<TableCell sortDirection={sortBy === "question_time" ? order : false}>
  <TableSortLabel
    active={true}
    direction={questionTimeOrder}
    onClick={() => {
      const newOrder = questionTimeOrder === "asc" ? "desc" : "asc";
      setQuestionTimeOrder(newOrder); // update visual arrow
      setSortBy("question_time");     // tell backend
      setOrder(newOrder);             // tell backend
    }}
  >
    Question Time
  </TableSortLabel>
</TableCell>


            </TableRow>
          </TableHead>
          <TableBody>
  {logs.map((log, index) => {
    const serialNumber = (page - 1) * pageSize + (index + 1);
    return (
      <TableRow key={log.log_id} hover>
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{log.email}</TableCell>
        <TableCell>
          <Tooltip title={log.query}>
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                maxWidth: 200,
              }}
            >
              {log.query}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title={log.response || ""}>
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                maxWidth: 200,
              }}
            >
              {log.response || "—"}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>{log.response_time}</TableCell>
        <TableCell>
          {log.question_time
            ? new Date(log.question_time).toLocaleString()
            : "—"}
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>

        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalCount} // from backend
        page={page - 1} // zero-based index
        onPageChange={(e, newPage) => setPage(newPage + 1)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(e) => {
          setPageSize(parseInt(e.target.value, 10));
          setPage(1);
        }}
        rowsPerPageOptions={[5, 10, 25, 50]} 
        sx={{mr:10}}
      />
    </>
  )}
</>


          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
